import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TargetAudienceSection } from './components/TargetAudienceSection';
import { LearningSection } from './components/LearningSection';
import { PreviewSection } from './components/PreviewSection';
import { PricingSection } from './components/PricingSection';
import { ReviewsSection } from './components/ReviewsSection';
import { FAQSection } from './components/FAQSection';
export function App() {
  return <main className="min-h-screen w-full bg-cream overflow-x-hidden selection:bg-coffee-light/30 selection:text-coffee-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TargetAudienceSection data-id="element-2" />
      <LearningSection data-id="element-3" />
      <PreviewSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <ReviewsSection data-id="element-6" />
      <FAQSection data-id="element-7" />

      {/* Footer */}
      
    </main>;
}